import { Injectable } from '@angular/core';
import { MeasurementDTO } from '@core/apis/measurement/measurement.dto';
import { CsvOsMeasurementService } from './csv-os-measurement.service';
import { CsvEcgMeasurementService } from './csv-ecg-measurement.service';
import { MeasurementTypeEnum } from '@oranta-mis/sdk';
import { DownloadFileFormatEnum } from '@core/enums/measurement.enum';

@Injectable({
  providedIn: 'root',
})
export class ReusableDownloadMeasurementsService {
  public isLoading: boolean = false;

  protected constructor(
    protected csvOsMeasurementService: CsvOsMeasurementService,
    protected csvEcgMeasurementService: CsvEcgMeasurementService,
  ) {}

  public generateMeasurementCsvFiles(selectedItems: MeasurementDTO[], onComplete?: () => void): void {
    const oscSignals: any[] = [];
    const ecgSignals: any[] = [];

    selectedItems.forEach((v) => {
      if (v['type'] === MeasurementTypeEnum.os) oscSignals.push(v);
      else if (v['type'] === MeasurementTypeEnum.ecg) ecgSignals.push(v);
    });

    if (oscSignals.length) {
      const csvDataOsc = this.csvOsMeasurementService.convertToCSV(oscSignals);
      this.downloadFile(csvDataOsc, DownloadFileFormatEnum.csv, 'os_measurements_data_' + new Date().toISOString());
    }
    if (ecgSignals.length) {
      const csvDataEcg = this.csvEcgMeasurementService.convertToCSV(ecgSignals);
      this.downloadFile(csvDataEcg, DownloadFileFormatEnum.csv, 'ecg_measurements_data_' + new Date().toISOString());
    }

    if (onComplete) onComplete();
  }

  public downloadMeasurementsJsonFiles(selectedItems: MeasurementDTO[], onComplete?: () => void) {
    this.downloadFile(
      JSON.stringify(selectedItems),
      DownloadFileFormatEnum.json,
      'measurement_data_' + new Date().toISOString(),
    );

    if (onComplete) onComplete();
  }

  private downloadFile(data: any, format: DownloadFileFormatEnum, fileName: string = 'data'): void {
    const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName + '.' + format;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
